import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import Pagination from 'assets/components/pagination/Pagination';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import { getLocales } from 'assets/locales/Locale';
import { DataProvider } from 'assets/providers/data/DataProvider';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import { HttpStatus, claimsHomeRoute } from 'config/Api.Config';
import { isDesktop, isMobile } from 'react-device-detect';
import useClaimJob from './ClaimJob.Hooks';
import { ClaimJobList } from './sections/Claim.ClaimJob.List';
import ClaimDelete from './sections/Claim.Delete';
import ClaimJobFilters from './sections/ClaimJob.Filters';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { useClaimCreatePageRouter } from 'app/pages/claims/createClaim/Index';

export const claimJobIndexRoute = claimsHomeRoute + '/claim-job/:action?/:id?';
export default function ClaimJobIndex() {
  const { lang } = getLocales();
  const claimJobHook = useClaimJob();
  const claimCreatePageRouter = useClaimCreatePageRouter();

  if (!claimJobHook.hasAnyPermission) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={claimJobHook}
        render={({ listApi, views, canAddClaim }) => (
          <>
            {views.delete && <ClaimDelete />}
            <Page
              class={ThemePageList}
              isLoading={listApi.isExecuting}
              header={
                <>
                  <h2 style={{ marginRight: 'auto' }} children={lang.claimJobs} />
                  <Box class={ThemeWrapperStack}>
                    {isMobile && <ClaimJobFilters />}
                    <Button
                      class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                      active
                      media={<Icon class="fas-plus" />}
                      render={!isMobile && lang.addNew}
                      disabled={!canAddClaim}
                      onClick={claimCreatePageRouter.redirect}
                    />
                  </Box>
                </>
              }
              subHeader={isDesktop && <ClaimJobFilters />}
              render={<ClaimJobList />}
              footer={
                <Pagination
                  class={ThemePaginationRounded}
                  count={listApi.payload?.count}
                  offset={listApi.body?.offset}
                  limit={listApi.body?.limit}
                  onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
                  onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
                />
              }
            />
          </>
        )}
      />
    </>
  );
}
